import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'cart-show-and-checkout-footer',
  templateUrl: './cart-show-and-checkout-footer.component.html',
  styleUrls: ['./cart-show-and-checkout-footer.component.scss']
})
export class CartShowAndCheckoutFooterComponent {
  @Input() checkoutBtnColor = 'btn-primary';
  @Output() onCheckout = new EventEmitter<void>();
}
